var React = require('react');

function Offline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.75 14.75c0 .413.338.75.75.75h3c.412 0 .75-.337.75-.75V14h-4.5v.75zM6 .5A5.256 5.256 0 0 0 .75 5.75 5.25 5.25 0 0 0 3 10.055v1.695c0 .412.338.75.75.75h4.5c.412 0 .75-.338.75-.75v-1.695a5.247 5.247 0 0 0 2.25-4.305A5.256 5.256 0 0 0 6 .5zm2.137 8.325l-.637.45V11h-3V9.275l-.638-.45A3.747 3.747 0 0 1 2.25 5.75C2.25 3.68 3.93 2 6 2c2.07 0 3.75 1.68 3.75 3.75 0 1.223-.6 2.37-1.613 3.075z","fill":"currentColor","fillRule":"evenodd"}));
}

Offline.defaultProps = {"width":"12","height":"16","viewBox":"0 0 12 16"};

module.exports = Offline;

Offline.default = Offline;
